import type { RunState } from "../meta/run-types";

// End-of-run summary: victory or defeat, what the operation earned, and the
// door back to the menu. Pure renderer.

export class RunOverScreen {
  private readonly el: HTMLElement;
  private onContinue: (() => void) | null = null;

  constructor() {
    this.el = document.createElement("div");
    this.el.id = "run-over";
    this.el.className = "screen-overlay";
    this.el.style.zIndex = "370";
    document.body.appendChild(this.el);
    this.el.addEventListener("click", (event) => {
      if ((event.target as HTMLElement | null)?.closest("#run-over-continue")) {
        this.hide();
        this.onContinue?.();
      }
    });
  }

  show(run: RunState, onContinue: () => void): void {
    this.onContinue = onContinue;
    const victory = run.outcome === "victory";
    const title = victory ? "OPERATION COMPLETE" : "OPERATION FAILED";
    const color = victory ? "#50ff78" : "#ff5050";
    const line = victory
      ? (run.fallen.length === 0
          ? "Alpha is on the bird. Everyone goes home."
          : "Alpha is on the bird. Not everyone goes home.")
      : "The operation ends here. What Alpha learned comes home in ops points.";

    const survivors = run.roster.length
      ? `<div class="run-memorial-line">CAME HOME &nbsp; <span class="run-operator">${run.roster.join(" · ")}</span></div>`
      : "";
    const fallen = run.fallen.length
      ? `<div class="run-memorial-line run-memorial-line--kia">KIA &nbsp; <span class="run-operator run-operator--kia">${run.fallen.join(" · ")}</span></div>`
      : "";

    const pad = (n: number) => n.toString().padStart(3, "0");
    this.el.innerHTML = `
      <div class="screen-panel screen-panel--narrow">
        <div class="screen-kicker">TOP SECRET // NOFORN</div>
        <div class="screen-title" style="color:${color};margin-bottom:16px">${title}</div>
        <div class="screen-copy" style="margin-bottom:14px">${line}</div>
        <div class="debrief-stats">
          <div>MISSIONS CLEARED &nbsp; <span style="color:#c8ffdc">${run.clearedNodeIds.length}/5</span></div>
          <div>KILLS &nbsp; <span style="color:#c8ffdc">${pad(run.kills)}</span></div>
          <div>FIELD MODS DRAFTED &nbsp; <span style="color:#c8ffdc">${run.modIds.length}</span></div>
        </div>
        <div class="run-memorial">${survivors}${fallen}</div>
        <div class="debrief-earned">+${run.opsEarned} OPS POINTS BANKED</div>
        <div class="screen-actions" style="margin-top:24px">
          <button id="run-over-continue" class="screen-button">RETURN TO BASE</button>
        </div>
      </div>
    `;
    this.el.classList.add("is-visible");
  }

  hide(): void {
    this.el.classList.remove("is-visible");
  }
}
